Array.prototype.switchPosition = function(from, to) {
	return this.splice(to, 0, this.splice(from, 1)[0]);
};
Array.prototype.max = function() {
	return Math.max.apply(null, this);
};
Array.prototype.min = function() {
	return Math.min.apply(null, this);
};
Array.prototype.remove = function(value){
	return this.filter(function(el){
		return el != value;
	});
}
Number.prototype.numberFormat = function(c, d, t) {
	var n = this,
	c = isNaN(c = Math.abs(c)) ? 2 : c,
	d = d == undefined ? "." : d,
	t = t == undefined ? "," : t,
	s = n < 0 ? "-" : "",
	i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
	j = (j = i.length) > 3 ? j % 3 : 0;
	return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
}

String.prototype.replaceAll = function(search, replacement) {
	let target = this;
	return target.replace(new RegExp(search, 'g'), replacement);
};
String.prototype.permalink = function(){
	var str = this;
	if(str=='') return '';
	let acentos = "ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç,";
	let replacement = "AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuunncc-";
	for (let i=0; i<acentos.length; i++) {
		str = str.replace(acentos.charAt(i), replacement.charAt(i));
	}
	var str = str.replace(/&.*?;/g, '').replace(/\s+/g, '-').replace(/[^\w\-]/g, '').toLowerCase();
	return str;
}
String.prototype.nl2br = function(){
	return (this).replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1 <br /> $2');
}

let check_fields = (arrFLD, FCTN) => {
	$(".required").removeClass("required");
	var pass = true;
	$.each(arrFLD,function(k,v){
		var fieldType = arrFLD[k].split(':');
		if($(fieldType[0]).length == 0){
			Swal({text:'Hubo un error inesperado. Intenta más tarde',type:'error'});
			return false;
		}
		if($(fieldType[0]).val().length > 0){
			///////////////////////////////////
			if(fieldType[1] == 'email'){
				var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
				if(!regex.test($(fieldType[0]).val())){
					$(fieldType[0]).addClass("required").effect('pulsate').focus();
					pass = false;
				}
			}
		}else{
			$(fieldType[0]).addClass("required").effect('pulsate').focus();
			pass = false;
		}
	});
	$('.required:eq(0)').focus();
	if(pass) FCTN();
}
let loading = obj => {
	let show = obj != undefined && 'show' in obj ? obj.show : true;
	let message = obj != undefined && 'message' in obj ? obj.message : '';
	if(show){
		$('#loading').addClass('active').find('.loading-text').html(message);
	}else{
		$('#loading').removeClass('active');
		if('callback' in obj){obj.callback();}
	}
}
let ajax = (url,obj) => {
	loading();
	if(obj==undefined) obj = {};
	return new Promise((resolve,reject) => {
		$.ajax({
			type:'POST',
			url:ROOT+'ajax/index.php?uri='+url,
			data:obj,
			dataType:'json',
			cache:false
		})
		.done(response => {
			if(response.status!='ok'){
				Swal.fire({type:'error',html:response.message});
				reject(response);
			};
			resolve(response);
		})
		.always(response=>{
			loading({show:false});
		})
		.fail(response => {
			let error = response.responseText;
			console.log(response.responseText);
			reject(error);
		});
	});
}
let get_form = f => {
	var fd = $(f).serializeArray();
	var d = {};
	d.required = [];
	$(fd).each(function(k,v) {
		if (d[this.name] !== undefined){
			if (!Array.isArray(d[this.name])) {
				d[this.name] = [d[this.name]];
			}
			d[this.name].push(this.value);
		}else{
			d[this.name] = this.value;
			if($(f).find(`[name="${this.name}"]`).prop('required')){
				d.required.push(this.name);
			}
		}
	});
	return d;
}
let object_to_formdata = obj => {
	const form_data = new FormData();
	for(var key in obj ) {
		form_data.append(key, obj[key]);
	}
	return form_data;

}
let logout = path => {
	ajax(path,{mode:'logout'})
	.then(data => {
		window.location.reload();
	});
}
let toggle_button = (el,status) => {
	if(status==1){
		$(el).find('i').removeClass('fa-toggle-off').addClass('fa-toggle-on');
	}else{
		$(el).find('i').removeClass('fa-toggle-on').addClass('fa-toggle-off');
	}
}
let random = (min, max) => {
	return Math.floor(Math.random() * (max - min)) + min;
}
let get_template = template => {
	return new Promise((resolve,reject)=>{
		var ajax = $.ajax({
			type:'GET',
			url:ROOT+'templates/'+template+'.php',
			cache:false
		})
		.done((data)=>{
			resolve(data);
		})
		.fail((data)=>{
			reject(data);
		});
	});

	/*return new Promise((resolve,reject)=>{
		axios.get(ROOT+'templates/'+template+'.php')
			.then(response=>{
				resolve(response);
			})
			.catch(error=>{
				reject(error);
			});
	});*/
}
let youtube_api = function(id){
	return new Promise((resolve,reject)=>{
		$.ajax({
			type:'GET',
			url:'https://www.googleapis.com/youtube/v3/videos?id='+id+'&key=AIzaSyAq3a2AC4jXd9AVmt646ZP_45Vd3oLJn7g&part=snippet'}
			)
			.done(data=>{
				resolve(data);
			})
			.fail(data=>{
				reject(data);
			});
	});
}
let get_id_video = function(input,site){
	let arrURL = {};
	let arrYT = {};
	let idvideo = "";
	switch(site){
		case 'vimeo':
			arrURL = input.split("/");
			if(arrURL.length==1) return false;
			idvideo = arrURL[arrURL.length-1];
			break;
		case 'youtube':
			arrURL = input.split("watch?v=");
			if(arrURL.length==1) return false;
			arrYT = arrURL[1].split("&");
			idvideo = arrYT[0];
			break;
	}
	return idvideo;
}
let change_language = function(id){
	ajax('site/languages/change',{id:id})
		.then(function(){
			window.location.reload();
		});
}